// extracted by mini-css-extract-plugin
module.exports = {"infoCollection":"infocollection_infoCollection__XBs5L","infoCollectionWin":"infocollection_infoCollectionWin__qjBDw"};